import {
  Avatar,
  Menu,
  UnstyledButton,
  Flex,
  Text,
  useMantineColorScheme,
} from "@mantine/core";

import { FiLogOut } from "react-icons/fi";
import { useAuth } from "../../context";
import { useTranslation } from "react-i18next";
import { createStyles } from "@mantine/emotion";
import { useMediaQuery } from "@mantine/hooks";

const useStyles = createStyles((theme) => {
  const { colorScheme } = useMantineColorScheme();

  return {
    unstyledButton: {
      display: "block",
      padding: theme.spacing.xs,
      borderRadius: theme.radius.sm,
      color: colorScheme === "dark" ? theme.colors.dark[0] : theme.black,

      "&:hover": {
        backgroundColor:
          colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
      },
    },
  };
});

export function User() {
  const { t } = useTranslation();
  const { logout, user } = useAuth();
  const { classes } = useStyles();
  const isMobile = useMediaQuery("(max-width: 992px)");

  if (user) {
    return (
      <Menu position="top" offset={20} width={215} radius="lg">
        <Menu.Target>
          <UnstyledButton className={classes.unstyledButton}>
            <Flex direction="row" align="center" gap="sm" justify="flex-end">
              {user?.firstName && user?.lastName && !isMobile && (
                <Text size="lg" c="dimmed" style={{ whiteSpace: 'nowrap' }}>
                  {user.firstName} {user.lastName}
                </Text>
              )}
              <Avatar radius="xl" size={40} />
            </Flex>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown style={() => ({ marginLeft: "-10px" })}>
          <Menu.Item onClick={logout} leftSection={<FiLogOut size={16} />}>
            {t("appShell.logout")}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    );
  } else {
    return <></>;
  }
}
